import React, { useEffect, useState } from 'react'
import error from '../Components/assets/images/error.gif'
import '../Components/assets/css/verify.css'
import { VERIFY_LINK, BaseUrl } from '../services/Url'
import { useNavigate, useParams } from 'react-router-dom'
import { Loader } from '../Components/Loader'

export const Verify = () => {
  const navigate = useNavigate()
  const [data, setData] = useState()
  const { type, id, token, activityId } = useParams()
  const [isLoading, setIsLoading] = useState(true)

  const checkLink = async () => {
    let CompleteUrl = BaseUrl + VERIFY_LINK
    let data = {
      group_id: id,
      token: token,
    }

    console.log('API Request Details:')
    console.log('URL:', CompleteUrl)
    console.log('Request Data:', data)
    console.log('Group ID:', id)
    console.log('Token:', token)

    try {
      const response = await fetch(CompleteUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })

      console.log('Response Status:', response.status)
      console.log('Response Headers:', response.headers)

      const responseData = await response.json()
      console.log('API Response:', responseData)

      setData(responseData)
      setIsLoading(false)
    } catch (error) {
      console.error('API Error:', error)
      setIsLoading(false)
    }
  }

  useEffect(() => {
    document.title = 'Join Group'
    console.log('=== VERIFY COMPONENT LOADED ===')
    console.log('currentRoute', window.location.pathname)
    console.log('The string /verify/ is present inside the currentRoute.')
    console.log('title', document.title)
    console.log('URL Parameters:', { type, id, token, activityId })
    console.log('Base URL:', BaseUrl)
    console.log('Verify Link Endpoint:', VERIFY_LINK)

    if (!activityId) {
      checkLink()
    }
  }, [])

  const platform = navigator.userAgent

  const isIOS = /iPhone|iPad|iPod/i.test(platform)
  const isAndroid = /Android/i.test(platform)
  const isWindows = /Windows/i.test(platform)

  useEffect(() => {
    console.log(platform, '>>>>>>')
  }, [platform])

  const handleGroupInvites = () => {
    console.log('Processing group invite response:', data)

    if (data?.message === 'Group Already Started.') {
      console.log('Group Already Started.')
    } else if (data?.message === 'Expired Link.') {
      console.log('The link has expired.')
    } else if (data?.message === 'Group not found.') {
      console.log('Group not found.')
    } else if (data?.message === 'Url is Valid.') {
      console.log('URL is valid, redirecting based on platform...')

      if (isIOS) {
        console.log('User is using an iOS device')
        // window.location.href = "https://apps.apple.com/gb/app/pardnerpal/id6449637975"
      } else if (isAndroid) {
        console.log('User is using an Android device')
        // window.location.href = 'https://play.google.com/store/apps/details?id=com.pardnerpal.android&hl=en-IN';
      } else if (isWindows) {
        console.log('User is using a Windows device')
        // window.location.href = 'https://www.youtube.com/'
      } else {
        console.log('User is not using iOS, Android, or Windows')
      }
    } else {
      console.log('Unknown response message:', data?.message)
    }
  }

  const handleReplaceInvites = () => {
    if (isIOS) {
      window.location.href =
        'https://apps.apple.com/gb/app/pardnerpal/id6449637975'
    } else if (isAndroid) {
      window.location.href =
        'https://play.google.com/store/apps/details?id=com.pardnerpal.android&hl=en-IN'
    }
  }

  useEffect(() => {
    if (activityId) {
      handleReplaceInvites()
    } else {
      handleGroupInvites()
    }
  }, [data, navigate])

  let platformName = 'Unknown'

  if (isAndroid) {
    platformName = 'Android'
  } else if (isIOS) {
    platformName = 'iOS'
  } else if (isWindows) {
    platformName = 'window'
  }

  return (
    <div className='userVrf_wpr'>
      {isLoading ? <Loader /> : ''}
      {data?.message === 'Group Already Started.' ? (
        <div className='useVrf_bx text-center'>
          <img width='120' height='120' src={error} alt='error' />
          Sorry! Group Already Started.
        </div>
      ) : data?.message === 'Expired Link.' ? (
        <div className='useVrf_bx text-center'>
          <img width='120' height='120' src={error} alt='error' />
          Sorry, The link has expired.
        </div>
      ) : data?.message === 'Group not found.' ? (
        <div className='useVrf_bx text-center'>
          <img width='120' height='120' src={error} alt='error' />
          Sorry, Group not found.
        </div>
      ) : data?.message === 'Url is Valid.' ? (
        <div> </div>
      ) : (
        ''
      )}
    </div>
  )
}
